import React, { useRef, useState } from 'react';
import {
  Typography,
  Modal,
  Card,
  Layout,
  MenuProps,
  Menu,
  ConfigProvider,
  Space,
  Flex,
  Pagination,
} from 'antd';

import dayjs, { Dayjs } from 'dayjs';
import Loader from './Loader';
import { FilterBar } from '../Header/FilterBar';
import RecordsList from '../Content/RecordList';
import EmptyRecord from '../Content/EmptyRecord';
import PageHeading from './PageHeading';
import PdfViewer from '../PDF/PDFViewer';
import {
  logInformedInventorEvent,
  logNewsletterEvent,
} from '../../services/ApiActions/newsletterAct';

const { Sider, Content } = Layout;
const { Title, Text } = Typography;

type MenuItem = Required<MenuProps>['items'][number];
//export type RangeValueType<DateType> = [start: DateType | null | undefined, end: DateType | null | undefined];
interface ArticleLayoutProps {
  pagination?: React.ReactNode;
  tabs: any;
  title: string;
  records: any[];
  selectedMenu?: any;
  menuItems: any;
  isLoading?: boolean;
  defaultDateRange?: any;
  selectedTab: any;
  onRangeChange?: any;
  onPriorityChange?: any;
  priority?: any;
  onAllClick: any;
  onTabClick: any;
  isNewsletter?: boolean;
  showPriorityFilter?: boolean;
  tabItemsCount?: any;
  showDateRange?: boolean;
}
const ArticleLayout: React.FC<ArticleLayoutProps> = ({
  pagination,
  tabs,
  title,
  records,
  selectedMenu,
  menuItems,
  isLoading,
  defaultDateRange,
  onRangeChange,
  onAllClick,
  selectedTab,
  onTabClick,
  isNewsletter,
  onPriorityChange,
  priority,
  showPriorityFilter,
  tabItemsCount,
  showDateRange,
}) => {
  const [open, setOpen] = useState(false);
  const [PDFURL, setPDFURL] = useState('');
  const [PDFTitle, setPDFTitle] = useState('');
  const [playingVideoId, setPlayingVideoId] = useState<string | null>(null);
  const [currentPDFPage, setCurrentPDFPage] = useState(1);
  const [totalPDFPages, setTotalPDFPages] = useState(1);
  const modalEventTimer = useRef<number | null>(null);
  //const [selectedTab, setSelectedTab] = useState('pdf');

  const dateFormat = 'DD-MM-YYYY';
  const headerHeight = '106px';
  const rangePresets = [
    { label: 'Today', value: [dayjs(), dayjs()] },
    { label: 'Yesterday', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    {
      label: 'This Month',
      value: [dayjs().startOf('month'), dayjs().endOf('month')],
    },
    {
      label: 'Last Month',
      value: [
        dayjs().add(-1, 'M').startOf('month'),
        dayjs().add(-1, 'M').endOf('month'),
      ],
    },
  ];
  const trackCall = (mediaType: string) => {
    const seletedMenu = menuItems.find(
      (item: any) => item.key === selectedMenu
    )?.name;

    const trackingData: any = {
      media_type: mediaType,
      title: PDFTitle,
      tab_name: seletedMenu,
    };

    let engagedTime = 0;
    if (modalEventTimer.current !== null) {
      engagedTime = (Date.now() - modalEventTimer.current) / 1000;
      modalEventTimer.current = null; // Reset after usage
    }

    if (mediaType.toLowerCase() === 'pdf') {
      const pdfReadPercentage = (currentPDFPage / totalPDFPages) * 100;
      trackingData.pdf_read_percentage = Number(pdfReadPercentage.toFixed(2));
    }
    if (engagedTime > 0) {
      trackingData.duration = Number(engagedTime.toFixed(2));
      logInformedInventorEvent(trackingData);
    }
  };
  const onReadMoreClick = (artitleHeading: string, pdfURL: string) => {
    setOpen(true);
    setPDFURL(pdfURL);
    setPDFTitle(artitleHeading);
  };
  const handleOnVideoPlay = (isPlaying: string | null) => {
    // If there's already a video playing and we're switching to a different one
    if (
      playingVideoId !== null &&
      isPlaying !== null &&
      playingVideoId !== isPlaying
    ) {
      // Track the previously playing video before switching

      trackCall('Video');
      // Start tracking the new video
      modalEventTimer.current = Date.now();
    }
    // If no video was playing before and we're starting one now
    else if (playingVideoId === null && isPlaying !== null) {
      modalEventTimer.current = Date.now();
    }
    // If we're pausing the video (isPlaying becomes null)
    else if (playingVideoId !== null && isPlaying === null) {
      trackCall('Video');
      modalEventTimer.current = null;
    }

    // Update the currently playing video ID
    setPlayingVideoId(isPlaying);
  };
  return (
    <>
      <PageHeading heading={title} />
      <Layout>
        <Sider
          width={220}
          style={{
            backgroundColor: 'transparent',
            maxHeight: `calc(100vh - ${headerHeight})`,
            overflow: 'auto',
          }}
        >
          <ConfigProvider
            theme={{
              components: {
                Menu: {
                  itemSelectedBg: '#001e5a',
                  itemSelectedColor: '#FFF',
                },
              },
            }}
          >
            <Menu
              key={Math.random()}
              className="secondary-menu"
              defaultSelectedKeys={[selectedMenu]}
              style={{
                backgroundColor: 'transparent',
                height: '100%',
                borderRight: 0,
              }}
              items={menuItems}
            />
          </ConfigProvider>
        </Sider>
        <Content
          style={{
            marginLeft: '20px',
            //width: '100%', //to fix expanding of container

            height: `calc(100vh - ${headerHeight})`,
          }}
        >
          {/*conditionally hide tabs*/}
          {FilterBar({
            tabs: selectedMenu == 'submenu-performance-report' ? [] : tabs,
            selectedTab,
            onTabClick,
            onAllClick,
            rangePresets,
            defaultDateRange,
            onRangeChange,
            dateFormat,
            onPriorityChange,
            priority,
            showPriorityFilter,
            showDateRange,
          })}
          {isLoading ? (
            <Loader style={{ marginTop: '20%', justifyContent: 'center' }} />
          ) : (
            <>
              <div
                style={{
                  fontWeight: '500',
                  paddingRight: '15px',
                  height: 'calc(100vh - 190px)',
                  overflowY: 'auto',
                }}
              >
                {records.length > 0 ? (
                  <>
                    <RecordsList
                      playingVideoId={playingVideoId}
                      tabs={tabs}
                      priority={priority}
                      isNewsletter={isNewsletter}
                      records={records}
                      selectedTab={selectedTab}
                      onReadMoreClick={onReadMoreClick}
                      onVideoPlay={(isPlaying, title) => {
                        handleOnVideoPlay(isPlaying);
                        setPDFTitle(title);
                      }}
                      onVideoEnd={() => {
                        trackCall('Video');
                      }}
                    />
                  </>
                ) : (
                  <EmptyRecord />
                )}
              </div>
              {pagination}
            </>
          )}

          <Modal
            title={PDFTitle}
            footer={null}
            centered
            open={open}
            onCancel={() => setOpen(false)}
            width={1200}
          >
            <PdfViewer fileUrl={PDFURL} />
          </Modal>
        </Content>
      </Layout>
    </>
  );
};

export default ArticleLayout;
